<template>
  <div class="error-404">
    <!-- Header - start -->
    <div class="header">
      <router-link class="nav-item home" to="/">{{verses.topbar.home}}</router-link>
    </div>
    <!-- Header - end -->

    <!-- Content - start -->
    <div class="content">
      <div class="page landing rounder-container-div" style="margin-top: 52px;">
        <div class="language-selector">
          <img
            src="../assets/en-us.png"
            @click="setLanguage('en-us')"
            v-bind:class="{ active: (selectedLanguage==='en-us') }"
            alt="Lipi for Business in English Language" 
          />
          <img
            src="../assets/bn-bd.png"
            @click="setLanguage('bn-bd')"
            v-bind:class="{ active: (selectedLanguage==='bn-bd') }"
            alt="Lipi for Business in Bengali/Bangla Language" 
          />
        </div>

        <div class="hero">
          <div class="big-brand" draggable="true">
            <div class="line1">{{verses.error404.line1}}</div>
            <div class="line2">{{verses.error404.line2}}</div>
          </div>

          <div class="primary-button-container">
            <router-link class="primary-button" to="/">{{verses.error404.homepageLink}}</router-link>
          </div>
        </div>
      </div>

      <div
        class="page about-us column center-main center-cross rounder-container-div"
        id="about-us"
      >
        <div class="column center-main about-us-container-div">
          <div class="authors"></div>
          <div class="about-company">{{verses.home.aboutUs}}</div>
          <div class="contact">
            <div class="title">{{verses.general.fullCompanyName}}</div>
            <div class="description">{{verses.general.anvilPhone}}</div>
            <div class="description">{{verses.general.email}}</div>
            <div class="description-unimportant">{{verses.general.address}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Content - end -->

    <footer class="footer">
      {{ verses.footer.lineOne }}
      <br />
      {{ verses.footer.lineTwo }}
    </footer>
  </div>
</template>

<style lang="scss" scoped>
@import "../styles/variables.scss";
@import "../styles/utils.scss";

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row-reverse;
  background: var(--color-whitesmoke);
  height: 50px;
  z-index: 100;
}

.header .nav-item {
  color: var(--clickable-text-color);
  margin: 15px 10px 15px 10px;
  cursor: pointer;
  text-decoration: none;
}

.header .nav-item:hover {
  color: var(--theme-color-light);
}

.header .nav-item:active {
  color: var(--theme-color-light);
}

/* ========================= Page ======================= */

.page {
  min-height: calc(100vh - 100px);
  padding-top: 50px;
  padding-bottom: 50px;
}

/* ========================= Page: Landing ======================= */

.page.landing {
  // background-color: var(--color-white);

  background: linear-gradient(
    -45deg,
    var(--theme-color) 0%,
    var(--theme-color) 15%,
    white 15%,
    white 100%
  );

  display: flex;
  align-items: center;
  justify-content: center;

  .language-selector {
    position: absolute;
    left: 32px;
    top: 72px;

    img {
      height: 24px;
      margin-right: 8px;
      cursor: pointer;
    }

    img.active {
      border-bottom: 2px solid var(--app-primary-color);
    }
  }
}

.page.landing .big-brand {
  //   color: var(--theme-color);
  text-align: center;
}

.page.landing .big-brand .line1 {
  font-size: 6vw;
  line-height: 100%;
}

.page.landing .big-brand .line2 {
  font-size: 2vw;
  max-width: 700px;
}

.page.landing .big-brand .line3 {
  font-size: 1.2vw;
  margin-top: 20px;
  text-align: center;
}

@media (max-width: 560px) {
  .page.landing .big-brand .line1 {
    font-size: 12vw;
    margin-bottom: 8px;
  }

  .page.landing .big-brand .line2 {
    font-size: 7vw;
  }

  .page.landing .big-brand .line3 {
    font-size: 4vw;
    margin-top: 10px;
    text-align: center;
  }
}

/* ========================= Page: About-us ======================= */

.authors {
  height: 540px;
  width: calc(100vw - 20px);
  // max-width: 800px;
  background-image: url(./../assets/authors.jpg);
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */

  @media (max-width: 560px) {
    height: 340px;
    width: calc(100vw - 4px);
  }
}

.page.about-us {
  background: linear-gradient(
    135deg,
    whitesmoke 0%,
    whitesmoke 20%,
    white 20%,
    white 100%
  );
}

.about-us-container-div {
  margin-left: 10px;
  margin-right: 10px;
}

.about-company {
  font-size: 20px;
  margin-top: 36px;
  margin-bottom: 36px;
  text-align: center;
}

.contact {
  margin-bottom: 36px;
  text-align: center;
  font-size: 18px;
}

.contact .title {
  font-size: 24px;
  margin-bottom: 26px;
  font-family: "Cinzel";
  color: var(--theme-color);
}

.contact .description {
  font-size: 18px;
}

.contact .description-unimportant {
  font-size: 15px;
}

.footer {
  text-align: center;
  font-size: 15px;
  color: var(--text-color-light);
  margin-bottom: 24px;
  margin-top: 24px;
  line-height: 160%;
  padding-left: 5px;
  padding-right: 5px;
}

@media (max-width: 560px) {
  .about-company {
    font-size: 18px;
  }
}

/* ========================= Generic / Common / Reusable ======================= */

.primary-button-container {
  text-align: center;
  margin-top: 30px;
  font-size: 18px;
  margin-bottom: 10vw;
}

.primary-button {
  color: white;
  background-color: #ff7043;
  padding: 10px 30px 10px 30px;
  border-radius: 4px;
  text-decoration: none;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6);
}

.primary-button:hover {
  background-color: #f4511e;
}

.primary-button:active {
  background-color: var(--theme-color-light);
}
</style>


<script>
export default {
  name: "anvil",
  components: {},

  metaInfo: {
    title: "Anvil Global Dynamics Ltd.",
    meta: [
      {
        name: "description",
        content:
          "We are a private for-profit organization mainly operating in the software services and IT industry."
      },
      {
        name: "keywords",
        content:
          "for-profit, organization, IT Industry, Software Development, Technology"
      }
    ]
  },

  data() {
    return {
      verses: window.languageSets[window.defaultLanguage], // fallback,
      selectedLanguage: window.defaultLanguage
    };
  },

  mounted: function() {
    window.scrollTo(0, 0);
    this.initLanguage();
  },

  methods: {
    setLanguage(key) {
      window.localStorage.setItem("--language", key);
      this.initLanguage();
    },

    initLanguage() {
      let key = window.localStorage.getItem("--language") || window.defaultLanguage;
      this.selectedLanguage = key;
      this.verses = window.languageSets[key];
    }
  }
};
</script>
